import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';

import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-checkout-card',
  imports: [MatCardModule],
  templateUrl: './checkout-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './checkout-card.component.scss',
})
export class CheckoutCardComponent {
  /**
   * Additional CSS classes to apply to the card
   * Default classes (checkout-card) are always applied
   */
  class = input<string>('');

  color = input<'default' | 'emphasized'>('default');

  /**
   * Combined class string for the card element
   */
  classString = computed(() => {
    const classes = ['checkout-card', `color-${this.color()}`];
    if (this.class()) classes.push(this.class());
    return classes.join(' ');
  });
}
